export class TableLayoutHelper  {
  private static originalStyles = new Map<HTMLElement, { marginTop: string, pageBreakBefore: string }>();
    private static addedHeaders: HTMLElement[] = []; 
 private static pageHeight = 860; 

  /**
   * Adds margin to tables to prevent page breaks
   * Returns array of tables that were modified for later restoration
   */
  static addMarginToTables(
    container: HTMLElement, 
    tableSelectors: string[] = ['table.rate-table', 'table.remarks-table']
    ): HTMLElement[] {
    const modifiedTables: HTMLElement[] = [];
    tableSelectors.forEach(selector => {

      const tables = container.querySelectorAll(selector);

      for (let i = 0; i < tables.length; i++) {
        const table = tables[i] as HTMLElement;

        const tableRect = table.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const tableOffset = tableRect.top - containerRect.top;
        const tableHeight = tableRect.height;
        const currentPagePosition = tableOffset % this.pageHeight;

        const wouldCrossPageBoundary = (currentPagePosition + tableHeight) > this.pageHeight;

        if (wouldCrossPageBoundary && currentPagePosition > 50) {

           let offset = 30;
        if (selector === 'table.remarks-table') {
          const isNearTop = currentPagePosition < 300;
          offset = isNearTop ? 50 : 100;
        }

          var marginNeeded = this.pageHeight - currentPagePosition + offset; 
          this.originalStyles.set(table, {
            marginTop: table.style.marginTop || '',
            pageBreakBefore: table.style.pageBreakBefore || ''
          });

          const component = TableLayoutHelper.findParentComponent(table);

          if (component && table.parentElement) {
            const headerRow = component.querySelector('tr.header-area');
            const hrElement = document.createElement('hr');

            if (headerRow) {
              const headerClone = headerRow.cloneNode(true) as HTMLElement;
              headerClone.style.marginTop = `${marginNeeded}px`;
              const headerCssText = headerClone.style.cssText;
              headerClone.style.cssText = headerCssText.replace(/margin-top:[^;]+;?/, '') + 
                                        `; margin-top: ${marginNeeded}px !important`;

    const wrapperTable = document.createElement('table');
    wrapperTable.style.width = '100%';
    wrapperTable.appendChild(headerClone);
    
   
    table.parentElement.insertBefore(wrapperTable, table);
    table.parentElement.insertBefore(hrElement, table);
    
    this.addedHeaders.push(wrapperTable);
    this.addedHeaders.push(hrElement);


            }

            modifiedTables.push(table);
          }
        }
      }
    });

    return modifiedTables;
  }

/**
 * Aligns divs with pdfAlignBottom class to the bottom of the page with a configurable offset
 * @param container The container element to search within
 * @param bottomOffset Offset from the bottom of the page in pixels (default: 20)
 * @returns Array of modified elements for later restoration
 */
static alignDivToBottomOfPage(
  container: HTMLElement,
  bottomMargin: number = 5

): HTMLElement[] {
  const modifiedElements: HTMLElement[] = [];
  
  let bottomAlignedDivs = container.querySelectorAll('div.pdfAlignBottom');
  for (let i = 0; i < bottomAlignedDivs.length; i++) {
    const div = bottomAlignedDivs[i] as HTMLElement;
    const divRect = div.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const divOffset = divRect.top - containerRect.top;
    const divHeight = divRect.height;
    const currentPagePosition = divOffset % this.pageHeight;

    const marginNeeded = (this.pageHeight + bottomMargin) - currentPagePosition - divHeight;
//    const marginNeeded = this.pageHeight - 100 - divHeight; // 100px from bottom
    console.log('Margin needed:', marginNeeded);
    
    if (marginNeeded > 0) {
      this.originalStyles.set(div, {
        marginTop: div.style.marginTop || '',
        pageBreakBefore: div.style.pageBreakBefore || ''
      });
      
      div.setAttribute('style', `margin-top: ${marginNeeded}px !important; ${div.getAttribute('style') || ''}`);
      div.style.marginTop = `${marginNeeded}px`;
      modifiedElements.push(div);
    }
  }
  
  return modifiedElements;
}


    /**
   * Find the parent component containing the header
   */
  static findParentComponent(element: HTMLElement): HTMLElement | null {
    let current: HTMLElement | null = element;

    while (current) {
      if (
        current.classList.contains('table-matrix') || 
        current.querySelector('tr.header-area')
      ) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  /**
   * Restores original styles to tables and removes added BR elements
   */
  static restoreTableStyles(tables: HTMLElement[]): void {
    tables.forEach(table => {
      const originalStyles = this.originalStyles.get(table);

      if (originalStyles) {
        table.style.marginTop = originalStyles.marginTop;
        table.style.pageBreakBefore = originalStyles.pageBreakBefore;

        this.originalStyles.delete(table);
      }
    });

    this.addedHeaders.forEach(header => {
      if (header.parentElement) {
        header.parentElement.removeChild(header);
      }
    });

    this.addedHeaders = [];
  }
}